import { PRIVATE } from '@/plugins/acl/const'
import comingSoonRoute from '@/router/utils/comingSoonRoute'

const communication = [
  {
    path: '/communication/email',
    name: 'communication-email-list',
    component: () => import('@/views/communication/email/email-list/EmailList.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.TEMPLATE.EMAIL,
    },
  },
  {
    path: '/communication/email/default/:action',
    name: 'communication-email-default-view',
    component: () => import('@/views/communication/email/default-email-view/DefaultEmailView.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.TEMPLATE.EMAIL,
      breadCrumb(context) {
        return [
          {
            text: 'email',
            useI18n: true,
            to: { name: 'communication-email-list' },
          },
          {
            text: context.emailTemplateName,
            useI18n: false,
          },
        ]
      },
    },
  },
  {
    path: '/communication/email/:id',
    name: 'communication-email-view',
    component: () => import('@/views/communication/email/email-view/EmailView.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.TEMPLATE.EMAIL,
      breadCrumb(context) {
        return [
          {
            text: 'email',
            useI18n: true,
            to: { name: 'communication-email-list' },
          },
          {
            text: context.emailTemplateName,
            useI18n: false,
          },
        ]
      },
    },
  },
  comingSoonRoute({
    path: '/communication/whatsapp',
    name: 'communication-whatsapp',
    comingSoonKey: 'communicationWhatsapp',
    resource: PRIVATE.COMMUNICATION.WHATSAPP,
    chickenImage: 'whatsappIntegration.png',
  }),
]

export default communication
